// HTTPS statuses and error codes that should not be logged as errors on Bugsnag
const nonLoggableResponses = {
  statuses: [0, 401, 404, 500, 501, 502, 503, 504],
  codes: [810, 801],
};

/**
 * Returns if we need to send this error to bugsnag
 * @param response - Axios response object
 * @returns true if the error should be sent to Bugsnag, false otherwise
 */
export function getShouldNotifyBugSnag(response: any): boolean {
  // Pas de response = on notifie (erreur inattendue)
  if (!response) {
    return true;
  }

  // Vérifier si le status ou le code d'erreur doit être ignoré
  if (
    nonLoggableResponses.statuses.includes(response?.status) ||
    nonLoggableResponses.codes.includes(response?.data?.code)
  ) {
    return false;
  }

  return true;
}
